export function handleClickAway(event) {
  function lookupUpDOM(element, targetKey) {
    const parentElement = element?.parentElement
    const parentKey = parentElement?.getAttribute?.('key')
    if (!parentElement) {
      return null
    }
    if (parentKey === targetKey) {
      return parentElement
    }

    return lookupUpDOM(parentElement, targetKey)
  }
  // Don't close if clicking the panel or its trigger
  const isFloatingPanelChildren = lookupUpDOM(event?.target, 'FloatingPanel')
  if (isFloatingPanelChildren) {
    return
  }

  const floatingPanelElement = this.getFloatingPanelElement()
  floatingPanelElement?.setNodeStyles?.({
    visibility: 'hidden',
    opacity: 0
  })
}
